import { render, staticRenderFns } from "./history-row.vue?vue&type=template&id=1a30b034&scoped=true&"
import script from "./history-row.vue?vue&type=script&lang=js&"
export * from "./history-row.vue?vue&type=script&lang=js&"
import style0 from "./history-row.vue?vue&type=style&index=0&id=1a30b034&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a30b034",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
